/* Comfiador Studio – winkelwagen-drawer */
(function () {
  const root = document.querySelector('[data-cs-cart]');
  if (!root) return;
  const $ = (s, el = root) => el.querySelector(s);
  const ds = root.dataset;
  const base = ds.root && ds.root !== '/' ? ds.root.replace(/\/$/, '') + '/' : '/';
  const body = $('[data-cs-cart-body]');
  const foot = $('[data-cs-cart-foot]');
  const progress = $('[data-cs-cart-progress]');
  const panel = $('.cs-cart__panel');
  const productCache = new Map();
  let busy = false;
  let lastFocus = null;

  const tiers = (ds.tiers || '').split(';').map(t => t.split('|')).filter(t => t.length === 2 && Number(t[0]) > 0)
    .map(t => ({ qty: Number(t[0]), label: t[1] })).sort((a, b) => a.qty - b.qty);

  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = c => new Intl.NumberFormat(document.documentElement.lang || 'bg', { style: 'currency', currency: ds.currency || 'EUR' }).format((c || 0) / 100);

  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
  }

  function renderProgress(count) {
    if (ds.progress !== 'true' || !tiers.length || count === 0) { progress.hidden = true; return; }
    const next = tiers.find(t => t.qty > count);
    const reached = [...tiers].reverse().find(t => t.qty <= count);
    let msg;
    if (next) msg = (ds.tProgress || '').replace('[qty]', '<b>' + (next.qty - count) + '</b>').replace('[pct]', '<b>' + esc(next.label) + '</b>');
    else msg = (ds.tProgressDone || '').replace('[pct]', '<b>' + esc(reached.label) + '</b>');
    const n = tiers.length;
    let fill = 0;
    for (let i = 0; i < n; i++) {
      const prevQty = i === 0 ? 0 : tiers[i - 1].qty;
      const seg = 1 / n;
      if (count >= tiers[i].qty) fill += seg;
      else { fill += seg * Math.max(0, (count - prevQty)) / (tiers[i].qty - prevQty); break; }
    }
    const marks = tiers.map((t, i) => '<span class="cs-cart__mark' + (count >= t.qty ? ' is-on' : '') + '" style="left:' + ((i + 1) / n * 100) + '%"><i></i><em>' + esc(t.label) + '</em></span>').join('');
    progress.innerHTML = '<p class="cs-cart__msg">' + msg + '</p><div class="cs-cart__bar"><div class="cs-cart__fill" style="width:' + Math.min(100, fill * 100) + '%"></div>' + marks + '</div>';
    progress.hidden = false;
  }

  async function getProduct(handle) {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(base + 'products/' + encodeURIComponent(handle) + '.js').then(r => r.ok ? r.json() : null).catch(() => null));
    }
    return productCache.get(handle);
  }

  function lineMarkup(item, product) {
    const realSave = Math.max(0, (item.original_line_price || 0) - (item.final_line_price || 0));
    let struck = realSave > 0 ? item.original_line_price : 0;
    let save = realSave;
    if (ds.savingsMode === 'compare' && product) {
      const v = product.variants.find(x => x.id === item.variant_id);
      if (false && v && v.compare_at_price > v.price) {
        struck = v.compare_at_price * item.quantity;
        save = struck - item.final_line_price;
      }
    }
    const img = item.image ? '<img src="' + esc(item.image) + (item.image.includes('?') ? '&' : '?') + 'width=240" alt="" width="120" height="150" loading="lazy">' : '';
    let selects = '';
    let optLabel = '';
    if (product && product.options && !(product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
      const current = product.variants.find(x => x.id === item.variant_id);
      optLabel = '<p class="cs-cart__opts">' + product.options.map(o => esc(o.name || o)).join(', ') + ':</p>';
      selects = '<div class="cs-cart__selects">' + product.options.map((o, idx) => {
        const values = o.values || [];
        if (values.length < 2) return '';
        return '<label class="cs-cart__select"><span class="visually-hidden">' + esc(o.name) + '</span><select data-cs-opt="' + idx + '">' +
          values.map(v => '<option' + (current && current.options[idx] === v ? ' selected' : '') + '>' + esc(v) + '</option>').join('') + '</select></label>';
      }).join('') + '</div>';
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      optLabel = '<p class="cs-cart__opts">' + esc(item.variant_title) + '</p>';
    }
    return '<li class="cs-cart__item" data-key="' + esc(item.key) + '" data-handle="' + esc(item.handle) + '" data-qty="' + item.quantity + '">' +
      '<a class="cs-cart__img" href="' + esc(item.url) + '">' + img + '</a>' +
      '<div class="cs-cart__info"><a class="cs-cart__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + optLabel + selects +
      '<div class="cs-cart__qty"><button type="button" data-cs-qty="-1" aria-label="' + esc(ds.tDec) + '">−</button><input type="number" min="0" value="' + item.quantity + '" data-cs-qty-input aria-label="qty"><button type="button" data-cs-qty="1" aria-label="' + esc(ds.tInc) + '">+</button></div></div>' +
      '<div class="cs-cart__side">' + (struck > item.final_line_price ? '<s>' + money(struck) + '</s>' : '') + '<strong>' + money(item.final_line_price) + '</strong>' +
      (save > 0 ? '<span class="cs-cart__save"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.4 11.6l-9-9A2 2 0 0011 2H4a2 2 0 00-2 2v7c0 .6.2 1.1.6 1.4l9 9a2 2 0 002.8 0l7-7a2 2 0 000-2.8zM6.5 8A1.5 1.5 0 116.5 5a1.5 1.5 0 010 3z"/></svg>' + esc(ds.tSave) + '<br>' + money(save) + '</span>' : '') +
      '<button type="button" class="cs-cart__del" data-cs-remove aria-label="' + esc(ds.tRemove) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg></button></div></li>';
  }

  async function render(cart) {
    updateCounts(cart.item_count || 0);
    renderProgress(cart.item_count || 0);
    if (!cart.item_count) {
      foot.hidden = true;
      body.innerHTML = '<div class="cs-cart__empty"><p class="cs-cart__empty-t">' + esc(ds.tEmptyTitle) + '</p><p>' + esc(ds.tEmptyCopy) + '</p><a class="cs-cart__cta" href="' + esc(ds.continueUrl) + '">' + esc(ds.tContinue) + '</a></div>';
      return;
    }
    const products = await Promise.all(cart.items.map(i => getProduct(i.handle)));
    let totalSave = 0;
    const lines = cart.items.map((item, i) => {
      const p = products[i];
      let s = Math.max(0, item.original_line_price - item.final_line_price);
      if (ds.savingsMode === 'compare' && p) {
        const v = p.variants.find(x => x.id === item.variant_id);
        if (false && v && v.compare_at_price > v.price) s = v.compare_at_price * item.quantity - item.final_line_price;
      }
      totalSave += s;
      return lineMarkup(item, p);
    }).join('');
    const orderLevel = Math.max(0, (cart.items_subtotal_price || 0) - (cart.total_price || 0));
    totalSave += orderLevel;
    body.innerHTML = '<ul class="cs-cart__items" role="list">' + lines + '</ul>';
    $('[data-cs-cart-total]').textContent = money(cart.total_price);
    const dRow = $('[data-cs-cart-discount-row]');
    dRow.hidden = totalSave <= 0;
    $('[data-cs-cart-discount]').textContent = '−' + money(totalSave);
    foot.hidden = false;
    const live = $('[data-cs-cart-live]');
    if (live) live.textContent = cart.item_count + ' · ' + money(cart.total_price);
  }

  async function refresh() {
    const cart = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
    await render(cart);
    return cart;
  }

  async function change(key, quantity) {
    if (busy) return;
    busy = true; root.classList.add('is-busy');
    try {
      const cart = await fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) }).then(r => r.json());
      await render(cart);
    } catch (e) { console.error(e); await refresh(); }
    finally { busy = false; root.classList.remove('is-busy'); }
  }

  async function swapVariant(li) {
    const product = await getProduct(li.dataset.handle);
    if (!product) return;
    const chosen = [...li.querySelectorAll('[data-cs-opt]')].reduce((acc, sel) => { acc[Number(sel.dataset.csOpt)] = sel.value; return acc; }, {});
    const current = li.dataset.key.split(':')[0];
    const match = product.variants.find(v => v.options.every((val, idx) => chosen[idx] === undefined || chosen[idx] === val));
    if (!match || String(match.id) === current) return;
    if (!match.available) { await refresh(); return; }
    busy = true; root.classList.add('is-busy');
    try {
      const qty = Number(li.dataset.qty) || 1;
      await fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: li.dataset.key, quantity: 0 }) });
      await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: match.id, quantity: qty }] }) });
    } finally { busy = false; root.classList.remove('is-busy'); }
    await refresh();
  }

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cs-cart-lock');
    document.querySelectorAll('[data-cart-toggle]').forEach(n => n.setAttribute('aria-expanded', 'true'));
    $('#csCartTitle').focus({ preventScroll: true });
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cs-cart-lock');
    document.querySelectorAll('[data-cart-toggle]').forEach(n => n.setAttribute('aria-expanded', 'false'));
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', e => {
    if (e.target.closest('[data-cs-cart-close]')) { close(); return; }
    const li = e.target.closest('.cs-cart__item');
    if (!li) return;
    const q = e.target.closest('[data-cs-qty]');
    if (q) { change(li.dataset.key, Math.max(0, Number(li.dataset.qty) + Number(q.dataset.csQty))); return; }
    if (e.target.closest('[data-cs-remove]')) change(li.dataset.key, 0);
  });
  root.addEventListener('change', e => {
    const li = e.target.closest('.cs-cart__item');
    if (!li) return;
    if (e.target.matches('[data-cs-qty-input]')) change(li.dataset.key, Math.max(0, Number(e.target.value) || 0));
    if (e.target.matches('[data-cs-opt]')) swapVariant(li);
  });
  document.addEventListener('keydown', e => {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = [...panel.querySelectorAll('a[href], button:not([disabled]), input, select')].filter(n => n.offsetParent);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  document.querySelectorAll('[data-cart-toggle]').forEach(t => {
    t.setAttribute('aria-haspopup', 'dialog');
    t.addEventListener('click', async e => { e.preventDefault(); await refresh(); open(); });
  });

  /* Toevoegen aan winkelwagen vanaf productformulieren */
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-product-form]')) return;
    const submitter = e.submitter;
    if (!submitter || submitter.getAttribute('name') !== 'add') return;
    e.preventDefault();
    const label = submitter.querySelector('[data-add-to-cart-label]');
    const labelText = label ? label.textContent : '';
    const err = form.querySelector('[data-add-to-cart-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    submitter.disabled = true;
    if (label) label.textContent = ds.tAdding || labelText;
    try {
      const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) { const d = await res.json().catch(() => null); throw new Error((d && (d.description || d.message)) || ''); }
      await refresh();
      open();
    } catch (error) {
      if (err) { err.textContent = error.message || err.dataset.genericError || ''; err.hidden = false; }
      else window.location.href = base + 'cart';
    } finally {
      submitter.disabled = false;
      if (label) label.textContent = labelText;
    }
  });

  /* Andere apps (bijv. bundels) kunnen de drawer verversen/openen */
  document.addEventListener('cart:refresh', () => refresh());
  document.addEventListener('cart:open', async () => { await refresh(); open(); });
  window.CSCart = { open: async () => { await refresh(); open(); }, close, refresh };
})();

